import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.send-verification-email', {
        url: '/send-verification-email',
        component: 'companyUserDirectoriesManageAccountSendVerificationEmail',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/send-verification-email/send-verification-email.state.js